import { css } from "@emotion/react";
import styled from "@emotion/styled";

import { DesignToken } from "@livechat/design-system-react-components";

import { withVar } from "themes/helpers";

export const Title = styled.p`
  font-size: 14px;
  line-height: 20px;
  padding-bottom: 6px;
  color: ${
    // FIXME: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
    (props: any) => props.theme.primaryColor
  };
`;

export const MainTitle = styled.p`
  font-size: 16px;
  font-weight: 700;
  line-height: 24px;
  padding-bottom: 16px;
  display: inline-block;
  color: ${
    // FIXME: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
    (props: any) => props.theme.primaryColor
  };
`;

export const Annotation = styled(Title)`
  color: ${
    // FIXME: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
    (props: any) => props.theme.primaryColor60
  };
`;

export const reportWrapperStyles = css`
  display: flex;
  flex-direction: column;
`;

export const selfAlignWrapperStyles = css`
  align-self: center;
`;

export const wrapperStyles = css`
  width: 360px;
  font-size: 14px;
  margin: 20px auto;
`;

export const buttonsWrapperStyles = css`
  padding: 20px 0;
`;

export const buttonsSpaceStyles = css`
  padding: 0 35px;
  margin-right: 10px;
`;

export const fieldGroupStyles = css`
  padding: 10px 0 20px;
`;

export const radioButtonStyles = css`
  padding-right: 25px;
  label {
    min-width: 90px;
  }
`;

export const iconStyles = css`
  padding-right: 10px;
`;

export const whiteLabelStyles = css`
  color: ${withVar(DesignToken.ContentInvertPrimary)};
`;

export const NextReportDate = styled.span<{ nextReport: string }>`
  color: ${
    // FIXME: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
    (props: any) => props.theme.primaryColor60
  };
  display: ${
    // FIXME: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
    (props: any) => (props.nextReport ? "inline" : "none")
  };
`;
